import type { TranslationKey } from './en.js';

export const ar: Partial<Record<TranslationKey, string>> = {
  'app.name': 'Volt',

  'section.chat': 'الدردشة',
  'section.image': 'الصور',
  'section.video': 'الفيديو',
  'section.video2': 'الفيديو 2 (Marketing Studio)',
  'section.character': 'الشخصية',
  'section.audio': 'الموسيقى والصوت',
  'section.voice': 'الصوت',
  'section.design': 'التصميم',

  'common.loading': 'جارٍ التحميل…',
  'common.error': 'حدث خطأ ما',
  'common.retry': 'إعادة المحاولة',
  'common.cancel': 'إلغاء',
  'common.confirm': 'تأكيد',
  'common.save': 'حفظ',
  'common.close': 'إغلاق',
  'common.delete': 'حذف',
  'common.create': 'إنشاء',
  'common.apply': 'تطبيق',
  'common.offline': 'غير متصل — عرض البيانات المخزنة',
  'common.you': 'أنت',
  'common.assistant': 'المساعد',
  'common.empty': 'لا شيء هنا بعد',
  'common.back': 'رجوع',

  'auth.loading': 'جارٍ تسجيل الدخول…',
  'auth.openInTelegram': 'افتحني داخل تيليجرام',
  'auth.openInTelegramHint':
    'يعمل Volt كتطبيق مصغّر في تيليجرام. شغّله من محادثتك مع البوت لتسجيل الدخول.',
  'auth.retry': 'إعادة المحاولة',
  'auth.error': 'تعذّر تسجيل الدخول',
  'auth.devHint': 'معاينة المطوّر — بدون بيانات تيليجرام.',

  'topbar.menu': 'فتح القائمة',
  'topbar.settings': 'الإعدادات',
  'topbar.balance': 'الرصيد',

  'directChat.open': 'افتح الدردشة الخاصة',
  'pager.chat': 'الدردشة',
  'pager.label': 'التنقل بين الصفحات',
  'directChat.title': 'الدردشة الخاصة',
  'directChat.yourId': 'معرّفك: {id}',
  'directChat.addPlaceholder': 'المعرّف العام أو اسم مستخدم تيليجرام @',
  'directChat.addFriend': 'إضافة صديق',
  'directChat.addSelf': 'لا يمكنك إضافة نفسك كصديق.',
  'directChat.friends': 'الأصدقاء',
  'directChat.noFriends': 'لا يوجد أصدقاء بعد. أضف مستخدمًا بالمعرّف العام أو اسم مستخدم تيليجرام.',
  'directChat.selectFriend': 'اختر صديقًا لفتح المحادثة.',
  'directChat.noMessages': 'لا توجد رسائل بعد. أرسل تحية!',
  'directChat.messagePlaceholder': 'اكتب رسالة…',
  'directChat.send': 'إرسال الرسالة',
  'directChat.notFound': 'لم يتم العثور على مستخدم بهذا المعرّف أو اسم مستخدم تيليجرام.',
  'directChat.noPermission': 'يمكنك مراسلة الأصدقاء فقط.',
  'directChat.addError': 'تحقق من المعرّف أو اسم المستخدم؛ ربما أضفت هذا الشخص من قبل.',
  'directChat.error': 'تعذّر تحميل الدردشة. حاول مرة أخرى.',
  'directChat.openDrawer': 'فتح المحادثات',
  'directChat.chats': 'المحادثات',
  'directChat.groups': 'المجموعات',
  'directChat.newGroup': 'مجموعة جديدة',
  'directChat.createGroup': 'إنشاء المجموعة',
  'directChat.groupName': 'اسم المجموعة',
  'directChat.selectMembers': 'اختر الأعضاء ({count}/50 بمن فيهم أنت)',
  'directChat.memberCount': '{count} أعضاء',
  'directChat.messages': 'الرسائل',
  'directChat.messageActions': 'إجراءات الرسالة',
  'directChat.reply': 'رد',
  'directChat.replyingTo': 'الرد على {name}',
  'directChat.forward': 'إعادة توجيه',
  'directChat.forwarded': 'معاد توجيهها',
  'directChat.chooseDestination': 'اختر محادثة لإعادة التوجيه',
  'directChat.deleteForMe': 'حذف لدي',
  'directChat.deleteForEveryone': 'حذف للجميع',
  'directChat.deleteForEveryoneConfirm': 'هل تريد حذف هذه الرسالة للجميع في المحادثة؟',
  'directChat.aiAttribution': 'الذكاء الاصطناعي',
  'directChat.aiToggleEnabled': 'تم تفعيل ردود الذكاء الاصطناعي',
  'directChat.aiToggleDisabled': 'تم تعطيل ردود الذكاء الاصطناعي',
  'directChat.aiGenerating': 'الذكاء الاصطناعي يجيب…',
  'directChat.aiGenerationError': 'فشل توليد رد الذكاء الاصطناعي: {error}',
  'directChat.aiChooseModel': 'اختر نموذج الذكاء الاصطناعي',
  'directChat.aiLongPressHint': 'اضغط مطولاً لاختيار النموذج',
  'directChat.sent': 'أُرسلت',
  'directChat.delivered': 'تم التسليم',
  'directChat.read': 'مقروءة',

  'sidebar.title': 'المحادثات',
  'sidebar.newChat': 'محادثة جديدة',
  'sidebar.search': 'بحث',
  'sidebar.searchPlaceholder': 'ابحث في المحادثات…',
  'sidebar.projects': 'المشاريع',
  'sidebar.newProject': 'مشروع جديد',
  'sidebar.noConversations': 'لا توجد محادثات بعد',
  'sidebar.archived': 'المؤرشفة',
  'sidebar.showArchived': 'عرض المؤرشفة',
  'sidebar.hideArchived': 'إخفاء المؤرشفة',
  'sidebar.pinned': 'المثبّتة',
  'sidebar.today': 'اليوم',
  'sidebar.yesterday': 'أمس',
  'sidebar.previous7Days': 'آخر 7 أيام',
  'sidebar.previous30Days': 'آخر 30 يومًا',
  'sidebar.older': 'أقدم',

  'menu.rename': 'إعادة تسمية',
  'menu.pin': 'تثبيت',
  'menu.unpin': 'إلغاء التثبيت',
  'menu.archive': 'أرشفة',
  'menu.unarchive': 'إلغاء الأرشفة',
  'menu.addToFolder': 'إضافة إلى مجلد',
  'menu.moveUp': 'للأعلى',
  'menu.moveDown': 'للأسفل',
  'menu.delete': 'حذف',
  'menu.deleteTitle': 'حذف المحادثة؟',
  'menu.deleteConfirm': 'ستُحذف هذه المحادثة ورسائلها نهائيًا.',

  'project.name': 'اسم المشروع',
  'project.description': 'الوصف',
  'project.systemPrompt': 'تعليمات مخصّصة',
  'project.systemPromptHint': 'تُرسل هذه التعليمات إلى النموذج في كل محادثة داخل المشروع.',
  'project.create': 'إنشاء مشروع',
  'project.empty': 'لا توجد مشاريع بعد',

  'composer.placeholder': 'راسل Volt…',
  'composer.imagePlaceholder': 'صف الصورة التي تريدها…',
  'composer.videoPlaceholder': 'صف الفيديو الذي تريده…',
  'composer.characterPlaceholder': 'صف الشخصية…',
  'composer.audioPlaceholder': 'صف الموسيقى أو الصوت…',
  'composer.voicePlaceholder': 'نص لتحويله إلى صوت…',

  'character.tabSoulId': 'معرّف الروح',
  'character.tabCharacter': 'الشخصية',
  'character.tabSoulCast': 'إسقاط الروح',
  'character.tabAiInfluencer': 'المؤثر بالذكاء الاصطناعي',
  'character.soulIdTitle': 'تدريب معرّف الروح',
  'character.characterTitle': 'الشخصيات',
  'character.soulCastTitle': 'إسقاط الروح',
  'character.aiInfluencerTitle': 'المؤثرون بالذكاء الاصطناعي',
  'character.name': 'الاسم',
  'character.description': 'الوصف',
  'character.bio': 'نبذة',
  'character.style': 'الأسلوب',
  'character.scene': 'المشهد',
  'character.prompt': 'الوصف',
  'character.referenceImages': 'روابط صور مرجعية، واحدة في كل سطر',
  'character.pickSoulId': 'اختر معرّف الروح',
  'character.pickCharacter': 'اختر شخصية',
  'character.noSoulLinked': 'بدون معرّف روح مرتبط',
  'character.scopeLabel': 'ما الذي تريد إنشاءه',
  'character.scopeHead': 'الرأس',
  'character.scopeFullBody': 'الجسم بالكامل',
  'character.scopeHeadHint': 'أفضل النتائج مع لقطات قريبة للوجه من زوايا مختلفة.',
  'character.scopeFullBodyHint': 'أضف صورًا للجسم بالكامل لإنشاء الجسم كاملًا.',
  'character.scopeBadgeHead': 'الرأس',
  'character.scopeBadgeFullBody': 'الجسم بالكامل',
  'character.model3dCreate': 'إنشاء نموذج ثلاثي الأبعاد',
  'character.model3dView': 'عرض ثلاثي الأبعاد',
  'character.model3dBuilding': 'جارٍ إنشاء النموذج ثلاثي الأبعاد… يستغرق بضع دقائق.',
  'character.model3dFailed': 'تعذّر إنشاء النموذج ثلاثي الأبعاد',
  'character.model3dRetry': 'أعد المحاولة',
  'character.model3dStarted': 'يجري إنشاء النموذج ثلاثي الأبعاد',
  'character.model3dStage': 'عارض النموذج ثلاثي الأبعاد',
  'character.model3dLoading': 'جارٍ تحميل النموذج…',
  'character.model3dError': 'تعذّر فتح النموذج ثلاثي الأبعاد.',
  'character.model3dUnsupported': 'جهازك لا يدعم ثلاثي الأبعاد (WebGL).',
  'character.model3dHint': 'اسحب للتدوير · اقرص أو استخدم العجلة للتكبير',
  'character.model3dReset': 'إعادة ضبط العرض',
  'character.model3dAutoRotate': 'تدوير تلقائي',
  'character.soulIdPhotoHint': 'حمّل من 5 إلى 20 صورة مرجعية.',
  'character.soulIdPhotoCount': 'يرجى اختيار من 5 إلى 20 صورة.',
  'character.soulIdUploadFailed': 'تعذّر رفع الصور. حاول مرة أخرى.',
  'character.createSoulId': 'إنشاء معرّف روح',
  'character.createCharacter': 'إنشاء شخصية',
  'character.createAiInfluencer': 'إنشاء مؤثر بالذكاء الاصطناعي',
  'character.generateSoulCast': 'إنشاء Soul Cast',
  'character.generateContent': 'إنشاء محتوى',
  'character.status.training': 'قيد التدريب',
  'character.status.ready': 'جاهز',
  'character.status.failed': 'فشل',
  'composer.send': 'إرسال',
  'composer.stop': 'إيقاف',
  'composer.attach': 'إرفاق ملفات',
  'composer.attachTitle': 'إضافة مرفق',
  'composer.attachAllPhotos': 'كل الصور',
  'composer.attachCamera': 'الكاميرا',
  'composer.attachPhotos': 'الصور',
  'composer.attachFiles': 'الملفات',
  'composer.attachFilesHint': 'الصور بدون ضغط',
  'composer.attachToFolder': 'إضافة إلى مجلد',
  'composer.voiceInput': 'إدخال صوتي',
  'composer.listening': 'أستمع…',
  'composer.thinking': 'أفكّر…',
  'composer.model': 'النموذج',
  'composer.selectModel': 'اختر نموذجًا',
  'composer.unavailable': 'غير متاح',
  'composer.estimate': '≈ {price}',
  'composer.topUpHint': 'اشحن رصيدك إلى {amount} للمتابعة',
  'composer.generate': 'توليد',

  'message.copy': 'نسخ',
  'message.copied': 'تم النسخ',
  'message.share': 'مشاركة',
  'message.regenerate': 'إعادة التوليد',
  'message.edit': 'تعديل',
  'message.save': 'حفظ وإعادة الإرسال',
  'message.up': 'إجابة جيدة',
  'message.down': 'إجابة سيئة',
  'message.usage': '{model} · {input} إدخال · {output} إخراج · {cost}',
  'message.usageNoModel': '{input} إدخال · {output} إخراج · {cost}',
  'message.failed': 'فشل التوليد',
  'message.reasoningTitle': 'مسار المعالجة',
  'conversation.pinnedBadge': 'محادثة مثبّتة',

  // TODO: translate share keys
  'share.button': 'Share',
  'share.createLink': 'Create link',
  'share.copyLink': 'Copy link',
  'share.copied': 'Copied!',
  'share.revoke': 'Revoke link',
  'share.revokeConfirm':
    'Are you sure you want to revoke this link? Anyone with the link will no longer be able to access it.',
  'share.title': 'Share conversation',
  'share.sharedBy': 'Shared snapshot',
  'share.notFound': 'This link has expired or been revoked.',
  'share.openApp': 'Open Volt',
  'share.loading': 'Loading…',
  'share.sendToChat': 'إرسال إلى المحادثة',
  'share.noDestinations': 'لا توجد محادثات أو مجموعات متاحة',
  'share.sentSuccess': 'تم الإرسال!',
  'share.sending': 'جارٍ الإرسال…',
  'share.loadingDestinations': 'جارٍ تحميل المحادثات…',
  'artifact.preview': 'معاينة',
  'artifact.code': 'الكود',
  'artifact.open': 'فتح العنصر',
  'artifact.export': 'تصدير',
  'artifact.download': 'تنزيل',
  'artifact.copy': 'نسخ',
  'artifact.edit': 'تعديل',
  'artifact.close': 'إغلاق',
  'artifact.fullscreen': 'ملء الشاشة',

  'job.status': 'الحالة',
  'job.pending': 'في الانتظار',
  'job.processing': 'قيد المعالجة…',
  'job.done': 'تم',
  'job.failed': 'فشل',
  'job.cancelled': 'أُلغي',
  'job.result': 'النتيجة',
  'job.empty': 'لا توجد عمليات توليد بعد',
  'job.actions': 'الإجراءات',
  'job.favoriteAdd': 'إضافة إلى المفضلة',
  'job.favoriteRemove': 'إزالة من المفضلة',
  'job.favorited': 'مفضل',
  'job.regenerate': 'إعادة التوليد',
  'job.viewPrompt': 'عرض الطلب',
  'job.promptTitle': 'الطلب',
  'job.download': 'تنزيل',
  'job.deleteTitle': 'حذف هذا التوليد؟',
  'job.deleteConfirm': 'سيتم حذف هذا التوليد نهائيًا.',

  'design.subtitle': 'افتح أداة تصميم في نافذة جديدة',
  'design.open': 'فتح',

  'settings.title': 'الإعدادات',
  'settings.profile': 'الملف الشخصي',
  'settings.appearance': 'المظهر',
  'settings.theme': 'السمة',
  'settings.themeLight': 'فاتح',
  'settings.themeDark': 'داكن',
  'settings.themeSystem': 'النظام',
  'settings.language': 'اللغة',
  'settings.balance': 'الرصيد',
  'settings.topup': 'شحن',
  'settings.topupAmount': 'المبلغ, ₽',
  'settings.topupSubmit': 'شحن الرصيد',
  'settings.transactions': 'سجل المعاملات',
  'settings.noTransactions': 'لا توجد معاملات بعد',
  'settings.loadMore': 'تحميل المزيد',
  'settings.notifications': 'الإشعارات',
  'settings.notificationsHint': 'إعلامي عند انتهاء عمليات التوليد',
  'settings.data': 'بياناتك',
  'settings.exportData': 'تصدير بياناتي',
  'settings.deleteAccount': 'حذف الحساب',
  'settings.deleteAccountTitle': 'حذف حسابك؟',
  'settings.deleteAccountConfirm': 'هذا يحذف حسابك ومحادثاتك ورصيدك نهائيًا. لا يمكن التراجع.',
  'settings.username': 'اسم المستخدم',
  'settings.name': 'الاسم',

  'admin.title': 'المشرف',
  'admin.stats': 'الإحصائيات',
  'admin.users': 'المستخدمون',
  'admin.settings': 'إعدادات المنصة',
  'admin.markup': 'الهامش, %',
  'admin.usdRub': 'سعر USD → RUB',
  'admin.minBalance': 'أدنى رصيد, ₽',
  'admin.contextLimit': 'رسائل السياق',
  'admin.models': 'أسعار النماذج',
  'admin.price': 'السعر',
  'admin.revenue': 'الإيرادات',
  'admin.cost': 'تكلفة المزوّد',
  'admin.margin': 'الربح',
  'admin.activeUsers': 'نشط (24 ساعة)',
  'admin.failedJobs': 'مهام فاشلة',
  'admin.ban': 'حظر',
  'admin.unban': 'رفع الحظر',
  'admin.adjustBalance': 'تعديل الرصيد',
  'admin.reason': 'السبب',
  'admin.amount': 'المبلغ, ₽',

  'error.UNAUTHORIZED': 'انتهت جلستك. أعد فتح التطبيق.',
  'error.FORBIDDEN': 'لا تملك صلاحية الوصول.',
  'error.USER_BANNED': 'تم إيقاف حسابك.',
  'error.NOT_FOUND': 'غير موجود.',
  'error.RATE_LIMITED': 'طلبات كثيرة جدًا. تمهّل.',
  'error.DAILY_LIMIT_EXCEEDED': 'بلغت الحد اليومي. حاول غدًا.',
  'error.INSUFFICIENT_BALANCE': 'الرصيد غير كافٍ لهذا الطلب.',
  'error.BELOW_MIN_BALANCE': 'رصيدك أقل من الحد الأدنى.',
  'error.MODEL_UNAVAILABLE': 'هذا النموذج غير متاح حاليًا.',
  'error.MODEL_NOT_SUPPORTED': 'هذا النموذج غير مدعوم هنا.',
  'error.PROVIDER_ERROR': 'أعاد المزوّد خطأ.',
  'error.PROVIDER_TIMEOUT': 'انتهت مهلة المزوّد.',
  'error.CONTEXT_TOO_LARGE': 'هذه المحادثة أطول من طاقة النموذج.',
  'error.PAYMENT_INVALID': 'تعذّرت معالجة الدفع.',
  'error.INTERNAL': 'خطأ في الخادم. حاول مجددًا.',
  'error.network': 'خطأ في الشبكة. تحقق من اتصالك.',
  'error.streamInterrupted': 'انقطع الاتصال. تم استعادة الرد من الخادم.',
  'error.generic': 'حدث خطأ ما.',
};
